import React from 'react';

function Input({ id, required = false, placeholder, className = 'form-control', type = 'text', label, ...restProps }) {
  return (
    <>
      <label htmlFor={id}>
        {label}
        {required ? <span className="requred">*</span> : ''}
      </label>
      <input type={type} className={className} id={id} placeholder={placeholder} required={required} {...restProps} />
    </>
  );
}

export default Input;
